import { useEffect } from "react";
import useViewsDispatch from "views/stores/useViewsDispatch";
import { selectQuery } from "views/logic/slices/viewSlice";
import useView from "views/hooks/useView";
import useActiveQueryId from "views/hooks/useActiveQueryId";
const CycleQueryTab = ({ interval, tabs = void 0 }) => {
  const view = useView();
  const activeQuery = useActiveQueryId();
  const dispatch = useViewsDispatch();
  useEffect(() => {
    const cycleInterval = setInterval(() => {
      if (!view || !activeQuery) {
        return;
      }
      const queryTabs = tabs || view.search.queries.toIndexedSeq().map((_, v) => v).toJS();
      const currentQueryIndex = view.search.queries.toIndexedSeq().findIndex((q) => q.id === activeQuery);
      const currentTabIndex = queryTabs.indexOf(currentQueryIndex);
      const nextQueryIndex = queryTabs[(currentTabIndex + 1) % queryTabs.length];
      const nextQueryId = view.search.queries.toIndexedSeq().get(nextQueryIndex).id;
      if (nextQueryId !== activeQuery) {
        dispatch(selectQuery(nextQueryId));
      }
    }, interval * 1e3);
    return () => clearInterval(cycleInterval);
  }, [interval, view, activeQuery, tabs, dispatch]);
  return null;
};
export default CycleQueryTab;
